import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useOfferTags } from 'cityads-v3/hooks/offers'
import { ThemeProvider as MuiThemeProvider, createTheme } from '@mui/material/styles'
import darkTheme from 'cityads-v3/utils/muiTheme/darkTheme'
import { useOfferFiltersContext } from '../../OfferFilters.hooks'
import classes from './BackToSchoolBanner.scss'

import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'

export const BACK_TO_SCHOOL_TAG = `BACK TO SCHOOL`

const buttonTheme = createTheme({
  palette: {
    primary: {
      main: '#FFFFFF'
    },
  },
})

export default function BackToSchoolBanner(): JSX.Element {
  const { t } = useTranslation(['main'])
  const [, tagsByCode] = useOfferTags()
  const offerFilters = useOfferFiltersContext()

  const handleSelectTag = useCallback(() => {
    if (offerFilters.selectedFilters.fields.tags.value.includes(BACK_TO_SCHOOL_TAG)) {
      offerFilters.refresh()
    } else {
      offerFilters.selectedFilters.fields.tags.pushToArray(BACK_TO_SCHOOL_TAG)
      offerFilters.selectedFilters.handleSubmit()
    }
  }, [offerFilters])

  if (!tagsByCode?.[BACK_TO_SCHOOL_TAG]?.is_available_in_filter) {
    return null
  }

  return (
    <MuiThemeProvider theme={darkTheme}>
      <div className={classes.container}>
        <div className={classes.banner}>
          <div className={classes.text}>
            <Typography
              color="textPrimary"
              variant="h6"
              className={classes.title}
            >{t('backToSchoolBanner.title')}</Typography>
            <Typography color="textSecondary" className={classes.description}>{t('backToSchoolBanner.description')}</Typography>

            <MuiThemeProvider theme={buttonTheme}>
              <Button
                color="primary"
                classes={{ root: classes.button }}
                onClick={handleSelectTag}
                variant="contained"
              >{t('backToSchoolBanner.button')}</Button>
            </MuiThemeProvider>
          </div>
        </div>
      </div>
    </MuiThemeProvider>
  )
}
